import { useState, useEffect } from 'react';

export default function SearchPagination({ totalItems, pageSize, pagesToShow, page, changePage }) {

    // calculate total, start and end pages
    const totalPages = Math.ceil(totalItems / pageSize);
    const currentPage = page ?? 1;

    const [startPage, endPage] = calcStartAndEnd(totalPages, pagesToShow, currentPage);

    let sp = startPage;
    const links = Array(endPage - sp + 1)
        .fill()
        .map(() => sp++)
        .map(p => 
            currentPage == p ? <li key={p} className="current"><span className="show-for-sr">You're on page</span> {p}</li> :
                <li key={p}><a onClick={() => changePage(p)} aria-label={'Page ' + p}>{p}</a></li>
    );
    
    function calcStartAndEnd(totalPages, pagesToShow, currentPage) {
        if (totalPages > pagesToShow) {
            let startPage = currentPage - pagesToShow / 2;
            let endPage = currentPage + (pagesToShow / 2) - 1;

            if (startPage <= 0) {
                endPage -= (startPage - 1);
                startPage = 1;
            }
            if (endPage > totalPages) {
                endPage = totalPages;
                if (endPage > pagesToShow) {
                    startPage = endPage - pagesToShow + 1;
                }
            }
            return [startPage, endPage];
        }
        else {
            return [1, totalPages];
        }
    }

    return (
        <div className="searchPagination d-block mt-4">
            <nav aria-label="Pagination">
                <ul className="pagination text-center pb-2 mb-0">
                    {currentPage == 1 ?
                        <li className="pagination-previous disabled"><span className="show-for-sr">Previous page</span></li>
                        :
                        <li className="pagination-previous"><a onClick={()=>changePage(currentPage-1)} aria-label="Previous page" rel="prev"><span className="show-for-sr">Previous page</span></a></li>
                    }

                    {links}

                    {endPage < totalPages && <li className="ellipsis" aria-hidden="true"></li>}

                    {currentPage < totalPages ?
                        <li className="pagination-next"><a onClick={() => changePage(currentPage+1)} aria-label="Next page" rel="next"><span className="show-for-sr">Next page</span></a></li>
                        :
                        <li className="pagination-next disabled"><span className="show-for-sr">Next page</span></li>
                    }
                </ul>
            </nav>            
        </div>
    )
}